module.exports = __webpack_public_path__ + "img/alphabet04.7d94081b.png";